import { maxLength, required } from "@vuelidate/validators";
export default class Local {
    constructor() {
        this.id = null;
        this.name = null;
        this.capMax = null;
        this.capMin = null;
        this.status = true;
    }
    validations() {
        return {
            name: {
                required,
                maxLength: maxLength(100)
            },
            capMax: {
                required,
            },
            capMin: {
                required,
            },
            status: {
                required,
              },
        }
    }
}